<template>
  <footer class="footer-area bg-white section-padding-xs mt-5" style="border-style: solid;border-width:2px 0 0 0;border-color:#999999;">
    <!-- Footer Top Area -->
    <div class="footer-top-area">
      <div class="container">
        <div class="row widgets footer-widgets">

          <!-- Single Widget -->
          <div class="col-lg-2 col-md-6 col-sm-6 col-12 text-center" >
            <img src="/img/logo/big-logo.png"/>
            <img src="/img/logo/com-logo1.png" style="width:50%;"/>
          </div>
          <!--// Single Widget -->

          <!-- Single Widget -->
          <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="single-widget widget-quicklinks">
              <h6 class="widget-title  border-bottom-0">Quick Contact</h6>
              <ul>
                <li><a href="mailto://customer@bukibags.com">customer@bukibags.com</a></li>
                <li><a href="tel:+00862036972013">0086 20 36972013</a></li>
                <li><a href="tel:+008615999928528">0086 15999928528</a></li>
              </ul>
            </div>
          </div>
          <!--// Single Widget -->


          <!-- Single Widget -->
          <div class="col-lg-2 col-md-6 col-sm-6 col-12">
            <div class="single-widget widget-quicklinks">
              <h6 class="widget-title border-bottom-0">Our Products</h6>
              <ul>
                <li><a href="/fashion-handbags/view-all?mainMaterial=PU">PU Leather</a></li>
                <li><a href="/fashion-handbags/view-all?mainMaterial=Genuine">Genuine Leather</a></li>
                <li><a href="/fashion-handbags/view-all?mainMaterial=Fabric">Fabric materials</a></li>
                <li><a href="/fashion-handbags/view-all">View All</a></li>
              </ul>
            </div>
          </div>
          <!--// Single Widget -->

          <!-- Single Widget -->
          <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="single-widget widget-quicklinks">
              <h6 class="widget-title border-bottom-0">Service & Support</h6>
              <ul>
                <li><a href="/blog/subject/list">NEWS</a></li>
                <li><a href="/faq">FAQ</a></li>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/">Home</a></li>
              </ul>
            </div>
          </div>
          <!--// Single Widget -->

          <!-- Single Widget -->
          <div class="col-lg-2 col-md-6 col-sm-6 col-12">
            <div class="single-widget widget-quicklinks">
              <h6 class="widget-title border-bottom-0">About Us</h6>
              <ul>
                <li><a href="/about-us">The Company</a></li>
                <li><a href="/about-factory">Factory</a></li>
                <li><a href="/about-production">Production</a></li>
              </ul>
            </div>
          </div>
          <!--// Single Widget -->

        </div>
      </div>
    </div>
    <!--// Footer Top Area -->

    <!-- Footer Copyright Area -->
    <div class="footer-copyright-area section-padding-top-xs">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-10">
            <p class="footer-copyright">wholesale leather handbags - www.bukibags.com - Factory in GuangZhou, China</p>
          </div>
          <div class="col-lg-2">
            <div class="footer-social-links float-right">
              <share></share>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--// Footer Copyright Area -->

  </footer>
</template>

<script>
    import share from '@/components/share'
    export default {
        name: "footer-com",
        components:{
          share
        }
    }
</script>

<style scoped>

</style>
